import { render, staticRenderFns } from "./EnvToggler.vue?vue&type=template&id=b74f63a4&scoped=true&"
import script from "./EnvToggler.vue?vue&type=script&lang=ts&"
export * from "./EnvToggler.vue?vue&type=script&lang=ts&"
import style0 from "./EnvToggler.vue?vue&type=style&index=0&id=b74f63a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74f63a4",
  null
  
)

export default component.exports